import { getLoginToken } from "./authService"

export async function callApi<R>(
  endpoint: string,
  type: "get" | "post",
  body?: any,
  options?: { useToken: boolean }
): Promise<R> {
  const authHeader = options?.useToken
    ? {
        Authorization: getLoginToken(),
      }
    : undefined
  const contentTypeHeader =
    type !== "get"
      ? {
          "Content-Type": "application/json",
        }
      : undefined
  const res = await fetch(`/api/v1/` + endpoint, {
    method: type,
    body: type === "get" ? undefined : JSON.stringify(body),
    headers: {
      ...authHeader,
      ...contentTypeHeader,
    },
  })
  const data: R = await res.json()
  return data
}

export async function callAuthedApi<R>(
  endpoint: string,
  type: "get" | "post",
  body?: any
): Promise<R> {
  return await callApi<R>(endpoint, type, body, {
    useToken: true,
  })
}
